import React from 'react';
import { formatAddress } from '../utils/web3';
import WalletConnect from './WalletConnect';

function Navbar({ account, onConnect, loading, onShowTelegram }) {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img src="/logo.png" alt="Smartcore" className="logo-treasure" />
          <span>SMARTCORE</span>
        </div>

        <div className="navbar-actions">
          {/* Telegram Button */}
          {account && (
            <button 
              className="telegram-btn"
              onClick={onShowTelegram}
              title="Telegram Notifications"
            >
              <img src="/telegram.png" alt="Smartcore" className="logo-treasure" />
            </button>
          )}
          
          <WalletConnect 
            account={account} 
            onConnect={onConnect} 
            loading={loading} 
          />
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
